import React from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import "./Svg.css";


function SvgLoad({x, y, Combinations }) {
    const { t, i18n } = useTranslation();

    let InverterConnectionMode = 1;
    let PAC1Load = 0; 
    let PAC2Load = 0; 
    let PAC3Load = 0; 
    let rows = [];
    let c1 = 0;
    let c2 = 0;
    let c3 = 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            let mode = 1;
            if (item.InverterConnectionMode != null) {
                mode = item.InverterConnectionMode;
                if (mode > InverterConnectionMode) {
                    InverterConnectionMode = mode;
                }
            }
            if (mode === 0 || mode === 1 || mode === 2) { 
                if (item.PAC1Load != null ) {
                    PAC1Load += parseInt(item.PAC1Load) * 0.001;
                }
                c1++;
            } else if (mode === 3) {
                if (item.PAC1Load != null ) {
                    PAC2Load += parseInt(item.PAC1Load) * 0.001;
                }
                c2++;
            } else if (mode === 4) {
                if (item.PAC1Load != null ) {
                    PAC3Load += parseInt(item.PAC1Load) * 0.001;
                }
                c3++;
            }

            rows.push({
                SN: item.SN,
                CreateTime: item.CreateTime,
                Phase: item.InverterConnectionMode,
                Power: item.PAC1Load != null ? (parseInt(item.PAC1Load) * 0.001).toFixed(3) : "",
            });
        });
    }
    

    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "600px",
            icon: null,
            title: t("Load Data"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase === 2 ? "(A)" : r.Phase === 3 ? "(B)" : r.Phase === 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("Power")+"(kW)", dataIndex: "Power",  align: "right" },
                ]}
                dataSource={rows}
            />),
            onOk() {
            },
        });
    };

    let count = Combinations?.length || 0;

    return (<svg xmlns="http://www.w3.org/2000/svg">
        <svg cursor={"pointer"} x={x} y={y} width={84} height={84}  version="1.1"  viewBox="0 0 83.13 73.76"
            onClick={handleClick}
        >
            <defs>
                <style>{`.cls-1{fill:#1d80b5;}.cls-2{fill:#fff;}`}</style>
            </defs>
            <rect x="0" y="0" width="83.13" height="73.76" fill="#fff" stroke="none" />
            <g>
                <g>
                    <path className="cls-1" d="M58.17-7.13h4.71a.52.52,0,0,1,.52.52V49.25a0,0,0,0,1,0,0H57.65a0,0,0,0,1,0,0V-6.61a.52.52,0,0,1,.52-.52Z" transform="translate(116.79 -9.63) rotate(132.2)" />
                    <path className="cls-1" d="M19.73-7.09h5.75a0,0,0,0,1,0,0V48.77a.52.52,0,0,1-.52.52H20.25a.52.52,0,0,1-.52-.52V-7.09A0,0,0,0,1,19.73-7.09Z" transform="translate(23.05 -9.82) rotate(47.8)" />
                    <path className="cls-1" d="M70.77,73.76H12.38a1.5,1.5,0,0,1-1.49-1.5l0-33.54L41.17,11.1,72.24,38.72l0,33.54A1.5,1.5,0,0,1,70.77,73.76Z" />
                    <rect className="cls-1" x="61.38" y="8.62" width="12.47" height="3.05" rx="0.4" />
                    <polygon className="cls-1" points="62.82 10.95 72.42 10.95 72.37 24.14 62.82 15.89 62.82 10.95" />
                    <path className="cls-2" d="M42.39,54.72c-2.5,0-6.85.05-8.83.06-.08,0,0-.15,0-.33,0-.37-.15-.93-.3-1-3.68-2.32-6.7-7.12-6.7-11.35A14.68,14.68,0,0,1,33,30.48,16.76,16.76,0,0,1,42,28" />
                    <path className="cls-2" d="M40.75,54.71c2.5,0,6.85,0,8.83.06.08,0,0-.15,0-.33,0-.37.15-.93.3-1,3.68-2.32,6.7-7.12,6.7-11.35a14.7,14.7,0,0,0-6.47-11.59,16.76,16.76,0,0,0-9-2.47" />
                    <path className="cls-2" d="M33.49,57.46H49.65a0,0,0,0,1,0,0v2.46a3.52,3.52,0,0,1-3.52,3.52H37a3.52,3.52,0,0,1-3.52-3.52V57.46A0,0,0,0,1,33.49,57.46Z" />
                    <rect className="cls-2" x="35.82" y="65.13" width="11.51" height="2.34" rx="0.9" />
                    <polygon className="cls-1" points="39.16 51.26 48.78 39.38 41.56 39.38 41.56 30.47 34.34 42.35 41.56 42.35 39.16 51.26" />
                </g>
            </g>
        </svg>
        {InverterConnectionMode === 1 ?
            <svg x={x + 84 + 10} y={y+84 - 50} >
                <text x={i18n.language === "en" ? 190: 130} y={20} fontSize="20" fill="black" textAnchor="end">{PAC1Load.toFixed(3)} kW{count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c1})</tspan>}</text>
                <text x={i18n.language === "en" ? 190: 130} y={50} fontSize="20" fill="black" textAnchor="end">{t("Consumption Power")}</text>
            </svg>
            :
            <svg x={x + 84 + 10} y={y+84 - 120} >
                <text x={i18n.language === "en" ? 190: 130} y={30} fontSize="20" fill="black" textAnchor="end">
                    {PAC1Load.toFixed(3)} kW
                    {count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c1})</tspan>}
                </text>
                <text x={i18n.language === "en" ? 190: 130} y={60} fontSize="20" fill="black" textAnchor="end">{PAC2Load.toFixed(3)} kW{count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c2})</tspan>}</text>
                <text x={i18n.language === "en" ? 190: 130} y={90} fontSize="20" fill="black" textAnchor="end">{PAC3Load.toFixed(3)} kW{count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c3})</tspan>}</text>
                <text x={i18n.language === "en" ? 190: 130} y={120} fontSize="20" fill="black" textAnchor="end">{t("Consumption Power")}</text>
            </svg>
        }
        
    </svg>)
}

export default SvgLoad